// src/apis/PaymentStatusApi.js
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { PAYMENT_STATUS} from "../services/actions";

const usePaymentStatus = () => {
  const dispatch = useDispatch();
  
  // Select payment data from Redux store
  const paymentData = useSelector((state) => state.payment?.statusData || null);
  const isLoading = useSelector((state) => state.payment?.loading || false);
  const error = useSelector((state) => state.payment?.error || null);

  const getPaymentStatus = useCallback((orderId, callback) => {
    console.log("═══════════════════════════════════════");
    console.log("🚀 [PaymentStatusApi] Dispatching API call");
    console.log("   Action:", `${PAYMENT_STATUS}_GET`);
    console.log("   Order ID:", orderId);
    console.log("   Endpoint:", `/api/payment/status/${orderId}/`);
    console.log("   Timestamp:", new Date().toLocaleTimeString());
    console.log("───────────────────────────────────────");
    
    
    dispatch({
      type: `${PAYMENT_STATUS}_GET`,
      payload: `payment/status/${orderId}/` ,
      callback: (resp) => {
        console.log("📨 [PaymentStatusApi] Raw Response:");
        console.log("───────────────────────────────────────");
        console.log("📦 Full Response:", resp);
        console.log("───────────────────────────────────────");
        
        // ✅ HANDLE DIRECT OBJECT RESPONSE (Your backend format)
        if (resp && resp.order_id) {
          console.log("✅ Valid payment response detected");
          console.log("───────────────────────────────────────");
          console.log("📄 Payment Details:");
          console.log("   ID:", resp.id);
          console.log("   Order ID:", resp.order_id);
          console.log("   Payment Status:", resp.payment_status);
          console.log("   Amount:", resp.payment_amount);
          console.log("   Gateway:", resp.gateway);
          console.log("   Customer ID:", resp.customer_id);
          console.log("   Loan Number:", resp.loan_number);
          console.log("   Customer Number:", resp.customer_number);
          console.log("   Module Code:", resp.module_code);
          console.log("   Attempt:", resp.attempt);
          console.log("   Created At:", resp.created_at);
          console.log("───────────────────────────────────────");
          console.log("🔹 Transaction Info:");
          console.log("   CF Payment ID:", resp.cf_payment_id || "N/A");
          console.log("   Bank Reference:", resp.bank_reference || "N/A");
          console.log("   Payment Method:", resp.payment_method || "N/A");
          console.log("   Payment Message:", resp.payment_message || "N/A");
          console.log("   Receipt No:", resp.reciept_no || "N/A");
          console.log("───────────────────────────────────────");
          
          // Normalize response for callback
          const normalizedResp = {
            is_success: true,
            data: {
              payment_status: resp.payment_status,
              order_id: resp.order_id,
              amount: parseFloat(resp.payment_amount),
              transaction_id: resp.cf_payment_id || resp.bank_reference,
              gateway: resp.gateway,
              upi_id: resp.customer_number,
              customer_id: resp.customer_id,
              loan_number: resp.loan_number,
              payment_method: resp.payment_method,
              created_at: resp.created_at,
              receipt_no: resp.reciept_no
            },
            raw: resp
          };
          
          console.log("🔄 [PaymentStatusApi] Normalized response:", normalizedResp);
          console.log("═══════════════════════════════════════");
          
          if (callback) {
            callback(normalizedResp);
          }
        } 
        // ✅ HANDLE ERROR RESPONSE
        else if (resp && resp.error) {
          console.log("❌ Error response:");
          console.log("   Error:", resp.error);
          console.log("   Message:", resp.message);
          console.log("═══════════════════════════════════════");
          
          if (callback) {
            callback({
              is_success: false,
              message: resp.message || "Payment status check failed",
              error: resp.error
            });
          }
        }
        // ⚠️ UNEXPECTED RESPONSE
        else {
          console.log("⚠️  Unexpected response format:", resp);
          console.log("═══════════════════════════════════════");
          
          if (callback) {
            callback({
              is_success: false,
              message: "Invalid response format",
              raw: resp
            });
          }
        }
      }
    });
  }, [dispatch]);

  return { 
    getPaymentStatus,
    paymentData,
    isLoading,
    error 
  };
};

export default usePaymentStatus;
